// MyProvider.js
import React, { useState } from 'react';
import MainContext from './MainContext';
// import { auth } from '../firebase';
// import { onAuthStateChanged } from 'firebase/auth';
// import { customUserByToken } from '../API/services';

const MainContextProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [lang1, setLang1] = useState(
    sessionStorage.getItem('lang') ? sessionStorage.getItem('lang') : 'en'
  );
  const [isLoggedIn,setIsLoggedIn] = useState(false);
  const [ctLoading, setCtLoading] = useState(true);
  const [contextValue, setData] = useState({    
      updatedPremiumDetails:{
        productName:'',
        totalPremium:'',
        addOns:[],
        prodData:{},
        policyType:'',
        serviceTax:'',
        idv:"",
        orderData:{},
        vehicleDetails:{}
      }
    });

  const [policyData, setPolicyData] = useState({ });
  const updateContextData = newValue => {
    // Create a copy of the data and update it immutably
    // console.log("newValue",newValue);
    const newData = { ...contextValue, 
        updatedPremiumDetails: {
          ...contextValue.updatedPremiumDetails,
          ...newValue
        } };
    setData(newData);
  };
  const updatePolicyContext = (val)=>{
    const newData = {
      ...policyData,
      ...val
    };
    setPolicyData(newData);
  }
  const loginHandler =(isLogin)=>{
    setIsLoggedIn(isLogin);
  };
  // useEffect(() => {
  //   // Check if user is logged in
  //   onAuthStateChanged(auth, (user) => {
  //     // console.log("user2222",user);
  //     if (user) {
  //       user.getIdToken().then(idToken =>{
  //         // console.log("idtoken",idToken);
  //         customUserByToken({'token':idToken,"application":'digi-life'}).then(res =>{
  //           // console.log("token22222",res);
  //           // debugger
  //           if(res.code ===0){
  //             setUser(res);
  //             setIsLoggedIn(true);
  //             setLoading(false);
  //           }else{
  //             // debugger
  //             setIsLoggedIn(false);
  //             setLoading(false);
  //           }
  //         }).catch((err)=>{
  //           console.log("err",err);
  //           setIsLoggedIn(false);
  //           setLoading(false);
  //           // navigate('/');
  //         });
  //       });
  //     }else{ 
  //       setIsLoggedIn(false);
  //       setLoading(false);
  //       // navigate('/');
  //     };
  // });
  // }, []);

  return (
    <MainContext.Provider value={{setLang1 , lang1 ,user,ctLoading,isLoggedIn,setUser, contextValue,setCtLoading,loginHandler, updateContextData,policyData,updatePolicyContext }}>
      {children}
    </MainContext.Provider>
  );
};

export default MainContextProvider;
